import moment from 'moment';

export const findDaysLeftDiff = (date) => {
  const dateNow = moment();
  const dueDate = moment(date);
  return dueDate.diff(dateNow, 'days');
};
